export default "__VITE_ASSET__sdQ9VHXa__"